import React from 'react';

const DeviceTitle = ({ record }) => {
	return <span>Device {record ? `"${record.name}"` : ''}</span>;
};
export default DeviceTitle;
